import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/search/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/app/src/search/Component.tsx");
